import {
  GET_ORDERS_PER_ZONE,
  GET_REJECTED_ORDERS_PER_ZONE,
  GET_SEARCH_ORDERS_PER_ZONE
} from "../actions/orderReports";

export default function(state = {}, action) {
  switch (action.type) {
    case GET_ORDERS_PER_ZONE:
      return { ...state, ...action.payload };
    case GET_REJECTED_ORDERS_PER_ZONE:
      return { ...state, rejectedId: action.payload };
    case GET_SEARCH_ORDERS_PER_ZONE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/orderReports.js